import { keepPreviousData, useQuery } from '@tanstack/react-query'
import client from '@/client'
import {
  NOTIFICATION_ENDPOINT,
  NOTIFICATION_POLL_MS,
  NOTIFICATION_QUERY_KEYS
} from '../constants/notification.constants'
import type { CustomEnvelope, NotificationList, NotificationListParams } from '../types/notification.types'

export const fetchListNotificationRequest = { method: 'GET', path: NOTIFICATION_ENDPOINT.list } as const

/** CUSTOM-NESTJS — notifikasi milik user aktif, terbaru di atas; saringan belum-dibaca / jenis / periode / cari. */
export async function fetchListNotification(params: NotificationListParams = {}): Promise<NotificationList> {
  const response = await client.api.get<CustomEnvelope<NotificationList>>(fetchListNotificationRequest.path, { params })
  return response.data.data
}

export function useFetchListNotification(
  params: NotificationListParams = {},
  options: { poll?: boolean; enabled?: boolean } = {}
) {
  return useQuery({
    queryKey: NOTIFICATION_QUERY_KEYS.list(params),
    queryFn: () => fetchListNotification(params),
    placeholderData: keepPreviousData,
    refetchInterval: options.poll ? NOTIFICATION_POLL_MS : false,
    enabled: options.enabled ?? true
  })
}
